import React, { useEffect, useState } from "react";
import "./Cart.scss";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useDispatch, useSelector } from "react-redux";
import { removeItem, resetCart, updateQuantity } from "../../redux/cartReducer";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";

const Cart = ({ closeCart }) => {
  const products = useSelector((state) => state.cart.products);
  const dispatch = useDispatch();
  const [isCheckout, setIsCheckout] = useState(false);

  //console.log(products);

  const delivaryAmout = 20;
  const delivaryAmoutLess = 10;
  const noDelivaryAmout = 0;

  const totalPrice = () => {
    let total = 0;
    products.forEach((item) => (total += item.quantity * item.price));
    return total.toFixed(2);
  };

  const netOder = Math.min(totalPrice());
  const withDelivaryCost = () => {
    if (netOder < 50) {
      const netTotal = netOder + delivaryAmout;
      return netTotal.toFixed(2);
    }
    if (netOder >= 50 && netOder < 75) {
      const netTotal = netOder + delivaryAmoutLess;
      return netTotal.toFixed(2);
    }
    if (netOder >= 75) {
      const netTotal = netOder + noDelivaryAmout;
      return netTotal.toFixed(2);
    } else {
      return;
    }
  };

  const finalCost = withDelivaryCost();
  let FinalNetPrice = withDelivaryCost();

  const massageDisplay_75 = () => {
    if (netOder < 75) {
      let value = 75 - netOder;
      return ` You're just AED ${value.toFixed(2)} away from free delivery! `;
    } else {
      return " 🥳  Woo.. hoo.. you're eligible for free delivery 🚚 ";
    }
  };

  const massgeDisplay_50 = () => {
    if (netOder < 50) {
      let valueTwo = 50 - netOder;
      return ` Or,Add just AED ${valueTwo.toFixed(
        2
      )} to slash your delivery fee to AED 10.`;
    } else {
      return;
    }
  };

  const comMessage = " 'Don't miss out—shop a little more and save big! ";
  const inital = netOder === 0 ? "hide" : "";



  return (
    <div className="__fw">
      {!isCheckout && (
        <div className="cart">
          <div className="cart_wrap" style={{ padding: "10px" }}>
            <h2 className="cart-head">
              Product <em>in your cart</em>{" "}
            </h2>

            {products?.map((item, i) => (
              <div className="item" key={i}>
                <img
                  src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.img}`}
                  alt={item.name}
                />

                <div className="details">
                  <div className="top">
                    <strong>
                      {item.title?.length > 50
                        ? item.title.substring(0, 50) + "..."
                        : item.title}{" "}
                    </strong>
                  </div>

                  <div className="bottom">
                    <span className="price">
                      {item.quantity}kg x AED {item.price} ={" "}
                      {item.quantity * item.price}AED
                    </span>

                    <div className="quantity-controls">
                      <button
                        onClick={() =>
                          dispatch(
                            updateQuantity({
                              id: item.id,
                              quantity:
                                item.quantity <= 5 ? 5 : item.quantity - 5,
                            })
                          )
                        }
                      >
                        -
                      </button>

                      <strong>{item.quantity} kg</strong>

                      <button
                        onClick={() =>
                          dispatch(
                            updateQuantity({
                              id: item.id,
                              quantity: item.quantity + 5,
                            })
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>

                <DeleteOutlinedIcon
                  className="delete"
                  onClick={() => dispatch(removeItem(item.id))}
                />
              </div>
            ))}

            <div className="total">
              <span>Products Total</span>
              <span>AED {totalPrice()}</span>
            </div>

            <div className="total">
              <span>Delivery Charges</span>
              {netOder < 50 ? (
                <p>AED 20.00</p>
              ) : netOder >= 50 && netOder < 75 ? (
                <p>AED 10.00</p>
              ) : (
                <p>Free</p>
              )}
            </div>

            <div className="sub_total">
              <span>SUBTOTAL</span>
              <div className={`${netOder === 0 ? "hide" : ""}`}>
                <span>AED {FinalNetPrice}</span>
              </div>
            </div>
            <div className="delivaryMsg">
              <span style={{ fontWeight: 400 }}>
                {massageDisplay_75()}
                {massgeDisplay_50()}
                Don't miss out—shop a little more and save big!
              </span>
            </div>
            {products.length ? (
              <Link
                to={{
                  pathname: "/check_out",
                  state: { products, finalCost },
                }}
              >
                <button className="checkout" onClick={closeCart}>
                  Proceed To Checkout
                </button>
              </Link>
            ) : (
              <Link
                to={{
                  pathname: "/Shop",
                }}
              >
                <button className="checkout" onClick={closeCart}>
                  Your Cart Empty
                </button>
              </Link>
            )}
            <div className="ct">
              <span className="reset" onClick={() => dispatch(resetCart())}>
                Clear Cart
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;
